import { Routes, Route, Navigate } from 'react-router-dom'

import SurveyList from 'Presentation/Views/Survey/List/View'
import FormSurvey from 'Presentation/Views/Survey/Form/View'
import { SurveyViewContextProvider } from 'Presentation/Views/Survey/Context'
import { FormSurveyContextProvider } from 'Presentation/Views/Survey/Form/Context'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const SurveyRoutes = () => (
  <SurveyViewContextProvider>
    <FormSurveyContextProvider>
      <Routes>
        <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.survey} />}>
          {/* Route: Create Survey */}
          <Route path='create' element={<FormSurvey />} />
          {/* Route: Create Survey */}

          {/* Route: Survey Detail */}
          <Route
            path=':id'
            element={
              <FormSurveyContextProvider>
                <FormSurvey />
              </FormSurveyContextProvider>
            }
          />

          {/* Route: Survey List */}
          <Route index element={<SurveyList />} />
          {/* Route: Survey List */}

          <Route path='*' element={<Navigate to='/home' />} />
        </Route>
      </Routes>
    </FormSurveyContextProvider>
  </SurveyViewContextProvider>
)

export default SurveyRoutes
